export default __webpack_public_path__ + "static/media/exitFullscreen.bcfb8b8a.svg";